import React from 'react'
import './OurPartners.css'
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";

const OurPartners = () => {

  const data = [
    "/assets/Image/aboutus/partner/img1.png",
    "/assets/Image/aboutus/partner/img2.png",
    "/assets/Image/aboutus/partner/img3.png",
    "/assets/Image/aboutus/partner/img4.png",
    "/assets/Image/aboutus/partner/img5.png",
    "/assets/Image/aboutus/partner/img6.png",
    "/assets/Image/aboutus/partner/img1.png",
    "/assets/Image/aboutus/partner/img2.png",
    "/assets/Image/aboutus/partner/img3.png",
    "/assets/Image/aboutus/partner/img4.png",
    "/assets/Image/aboutus/partner/img5.png",
    "/assets/Image/aboutus/partner/img6.png",
  ]

  return (
    <section className='OurPartners'>
      <div className='container'>

        <div className='main_div'>
          <h1 className='section_heading'>Our Finance Partners</h1>

          <div className='swiper_div'>
            <Swiper
              spaceBetween={15}
              pagination={{
                dynamicBullets: true,
                clickable: true
              }}
              modules={[Pagination]}
              autoplay={{ delay: 300 }}
              breakpoints={{
                0: {
                  slidesPerView: 1.2,
                  spaceBetween: 10,
                },
                350: {
                  slidesPerView: 2,
                  spaceBetween: 10,
                },
                420: {
                  slidesPerView: 1.4,
                  spaceBetween: 10,
                },
                486: {
                  slidesPerView: 2.5,
                  spaceBetween: 10,
                },
                768: {
                  slidesPerView: 4,
                  spaceBetween: 10,
                },
                992: {
                  slidesPerView: 4.8,
                  spaceBetween: 10,
                },
                1200: {
                  slidesPerView: 5.5,
                  spaceBetween: 10,
                },
                1400: {
                  slidesPerView: 6,
                  spaceBetween: 15,

                },


              }}
            >

              {data?.map((item) => {
                return (
                  <SwiperSlide >
                    <div className='logo_card_holder'>
                      <div className='logo_div'>
                        <img src={item} className='logo_img'/>
                      </div>
                    </div>
                  </SwiperSlide>
                )
              })}



            </Swiper>
          </div>

        </div>


      </div>
    </section>
  )
}

export default OurPartners
